import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import { MENU } from '../data/menu'
import { NATIONALITES } from '../data/nationalites'
import { NIVEAUX_ARBITRES } from '../data/niveaux_arbitres'
import { TYPES_BUTS_MARQUES } from '../data/types_buts_marques'
import { TYPES_CONTRAT_JOUEURS } from '../data/types_contrat_joueurs'
import { FONCTIONS_STAFF } from '../data/fonctions_staff'

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    //online
    baseURL: 'http://adminpanelfcrobi.ridiluamba.com/restapi/v1/',
    baseFileURL: 'http://adminpanelfcrobi.ridiluamba.com/restapi/',
    //online
/*
    baseURL: 'http://restapifcrobi.ridiluamba.com/v1/',
    baseFileURL: 'http://restapifcrobi.ridiluamba.com/',
*/
    //localhost
    // baseURL: 'http://localhost/myprojects/zoom243/restapi_fcrobi/v1/',
    // baseFileURL: 'http://localhost/myprojects/zoom243/restapi_fcrobi/',
    menu: MENU,
    nationalites: NATIONALITES,
    niveaux_arbitres: NIVEAUX_ARBITRES,
    types_buts_marques: TYPES_BUTS_MARQUES,
    types_contrat_joueurs: TYPES_CONTRAT_JOUEURS,
    fonctions_staff: FONCTIONS_STAFF,
    admin: null,
    messageAdminConnexion: null,
    messageSuccessRequest: null,
    messageFailedRequest: null,
    nom_utilisateur: null,
    arbitres: null,
    articles: null,
    buteurs: null,
    championnats: null,
    classements: null,
    equipes: null,
    joueurs: null,
    matchs_joues: null,
    matchs_non_joues: null,
    messages: null,
    resultats: null,
    saisons: null,
    sanctions: null,
    staffs: null,
    terrains: null,
  },
  getters: {
    getBaseURL: state => {
      return state.baseURL;
    },
    getNiveauxArbitres: state => {
      return state.niveaux_arbitres;
    },
    getTypesButsMarques: state => {
      return state.types_buts_marques;
    },
    getTypesContratJoueurs: state => {
      return state.types_contrat_joueurs;
    },
    getFonctionsStaff: state => {
      return state.fonctions_staff;
    },
    getBaseFileURL: state => {
      return state.baseFileURL;
    },
    getMenu: state => {
      return state.menu
    },
    getNationalites: state => {
      return state.nationalites
    },
    getMessageAdminConnexion: state => {
      return state.messageAdminConnexion
    },
    getMessageSuccessRequest: state => {
      return state.messageSuccessRequest
    },
    getMessageFailedRequest: state => {
      return state.messageFailedRequest
    },
    getAdmin: state => {
      return state.admin
    },
    getArbitres: state => {
      return state.arbitres
    },
    getArticles: state => {
      return state.articles
    },
    getButeurs: state => {
      return state.buteurs
    },
    getChampionnats: state => {
      return state.championnats
    },
    getClassements: state => {
      return state.classements
    },
    getEquipes: state => {
      return state.equipes
    },
    getJoueurs: state => {
      return state.joueurs
    },
    getMatchs_joues: state => {
      return state.matchs_joues
    },
    getMatchs_non_joues: state => {
      return state.matchs_non_joues
    },
    getMessages: state => {
      return state.messages
    },
    getResultats: state => {
      return state.resultats
    },
    getSaisons: state => {
      return state.saisons
    },
    getSanctions: state => {
      return state.sanctions
    },
    getStaffs: state => {
      return state.staffs
    },
    getTerrains: state => {
      return state.terrains
    },
  },
  mutations: {
    setMenu (state, menu) {
      state.menu = menu
    },
    setAdmin (state, admin) {
      state.admin = admin
    },
    setMessageAdminConnexion (state, messageAdminConnexion) {
      state.messageAdminConnexion = messageAdminConnexion
    },
    setMessageSuccessRequest (state, messageSuccessRequest) {
      state.messageSuccessRequest = messageSuccessRequest
    },
    setMessageFailedRequest (state, messageFailedRequest) {
      state.messageFailedRequest = messageFailedRequest
    },
    setArbitres (state, arbitres) {
      state.arbitres = arbitres
    },
    setArticles (state, articles) {
      state.articles = articles
    },
    setButeurs (state, buteurs) {
      state.buteurs = buteurs
    },
    setChampionnats (state, championnats) {
      state.championnats = championnats
    },
    setClassements (state, classements) {
      state.classements = classements
    },
    setEquipes (state, equipes) {
      state.equipes = equipes
    },
    setJoueurs (state, joueurs) {
      state.joueurs = joueurs
    },
    setMatchs_joues (state, matchs_joues) {
      state.matchs_joues = matchs_joues
    },
    setMatchs_non_joues (state, matchs_non_joues) {
      state.matchs_non_joues = matchs_non_joues
    },
    setMessages (state, messages) {
      state.messages = messages
    },
    setResultats (state, resultats) {
      state.resultats = resultats
    },
    setSaisons (state, saisons) {
      state.saisons = saisons
    },
    setSanctions (state, sanctions) {
      state.sanctions = sanctions
    },
    setStaffs (state, staffs) {
      state.staffs = staffs
    },
    setTerrains (state, terrains) {
      state.terrains = terrains
    },
  },
  actions: {
    sign_out ({commit}){
      sessionStorage.removeItem('token')
      commit('setAdmin', null)
    },
    axiosAdminAuthentication ({commit, state, dispatch}, dataForm) {
      return dispatch('axiosGetAllData', {table: 'admin'})
          .then(data => {
            const admin = data.data[0]
            let newDataForm = Object.assign({}, dataForm);
            newDataForm.admin_id = admin.admin_id
            return axios.post(state.baseURL+ newDataForm.table + '/authentication', JSON.stringify(newDataForm))
                .then(response => {
                    if (response.data.status === "reussite"){
                      commit('setMessageAdminConnexion', response.data.message)
                      sessionStorage.setItem('token', response.data.data.token)
                      commit('setAdmin', response.data.data)
                    }
                    else{
                      commit('setMessageAdminConnexion', response.data.message)
                      sessionStorage.removeItem('token')
                      commit('setAdmin', null)
                    }
                    return response
                })
                .catch(error => {
                  commit('setMessageFailedRequest', 'Erreur de conexion... Veuillez connecter le service client de zoom243')
                  commit('setAdmin', null)
                  return error
                });
          })
          .catch(error => {
            console.log(error)
          })
    },
    axiosRemoveFileData ({state}, data) {
      return axios.delete(state.baseFileURL + 'remove_file.php', data)
          .then(response => {
            // console.log(response);
            return [true, response.data.message, '']
          })
          .catch(error => {
            console.log(error);
            if(error.response) console.log(error.response)
          });
    },
    axiosPostFileData ({state}, data) {
      return axios.post(state.baseFileURL + 'upload_file.php', data,
          { headers: {'Content-Type': 'multipart/form-data'} })
          .then(response => {
            // console.log(response);
            return [true, response.data.message, response.data.src]
          })
          .catch(error => {
            let message = '';
            if(error.response){
              for (const errMsg in error.response.data.message)
                message += error.response.data.message[errMsg] + '<br>';
              // console.log(error.response);
            }
            // console.log(error);
            return [false, message, error.response.data.src]
          });
    },
    axiosPostData ({commit, state, dispatch}, data) {
      return axios.post(state.baseURL+ data.table + '/', JSON.stringify(data), {})
          .then(response => {
            if(response.data.status === 'reussite') commit('setMessageSuccessRequest', response.data.messages)
            else commit('setMessageFailedRequest', response.data.messages)
            return response
          })
          .catch(error => {
            commit('setMessageFailedRequest', 'Erreur de conexion... Veuillez connecter le service client de zoom243')
            return error
          });
    },
    axiosGetAllData ({commit, state, dispatch}, data) {
      return axios.get(state.baseURL + data.table + '/', {})
          .then(response => {
            if(response.data.status === 'reussite') commit('setMessageSuccessRequest', response.data.messages)
            else commit('setMessageFailedRequest', response.data.messages)
            commit('set' + data.table.charAt(0).toUpperCase() + data.table.slice(1), response.data.data)
            return response.data;
          })
          .catch(error => {
            commit('setMessageFailedRequest', 'Erreur de conexion... Veuillez connecter le service client de zoom243')
            return error;
          });
    },
    axiosGetOneData ({commit, state, dispatch}, data) {
      return axios.get(state.baseURL + data.table + '/' + data.table_id)
          .then(response => {
            if(response.data.status === 'reussite') commit('setMessageSuccessRequest', response.data.messages)
            else commit('setMessageFailedRequest', response.data.messages)
            return response.data;
          })
          .catch(error => {
            commit('setMessageFailedRequest', 'Erreur de conexion... Veuillez connecter le service client de zoom243')
            return error;
          });
    },
    axiosPutData ({commit, state, dispatch}, data) {
      return axios.put(state.baseURL + data.table + '/' + data.table_id, JSON.stringify(data), {})
          .then(response => {
            return response
          })
          .catch(error => {
            commit('setMessageFailedRequest', 'Erreur de conexion... Veuillez connecter le service client de zoom243')
            return error;
          });
    },
    axiosDeleteData ({commit, state, dispatch}, data) {
      return axios.delete(state.baseURL + data.table + '/' + data.table_id)
          .then(response => {
            console.log(response);
          })
          .catch(error => {
            commit('setMessageFailedRequest', 'Erreur de conexion... Veuillez connecter le service client de zoom243')
          });
    },
    axiosGetNumRows ({commit, state, dispatch}, data) {
      return axios.get(state.baseURL + 'total_' + data.table)
          .then(response => response.data)
          .catch(error => {
            commit('setMessageFailedRequest', 'Erreur de conexion... Veuillez connecter le service client de zoom243')
          })
    },
    axiosGetPaginatedData ({commit, state, dispatch}, data) {
      return axios.get(state.baseURL + 'pagination_' + data.table + '/' + data.pageIdx + '/' + data.pageNum)
          .then(response => {
            return response.data;
          })
          .catch(error => {
            commit('setMessageFailedRequest', 'Erreur de conexion... Veuillez connecter le service client de zoom243')
            return error;
          });
    }
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js